import { render, staticRenderFns } from "./ModelImg.vue?vue&type=template&id=0e5813e2&scoped=true&"
import script from "./ModelImg.vue?vue&type=script&lang=js&"
export * from "./ModelImg.vue?vue&type=script&lang=js&"
import style0 from "./ModelImg.vue?vue&type=style&index=0&id=0e5813e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5813e2",
  null
  
)

export default component.exports